export default __webpack_public_path__ + "static/media/attic.f60398b3.mp4";